export const filterAvailableVals = (availableVals, text, groups) => {
    if (text !== "") {
        var filteredVals = [];
        for (var i = 0; i < availableVals.length; i++) {
            if (availableVals[i].name.toLowerCase().includes(text.toLowerCase())) {
                filteredVals.push(availableVals[i]);
                continue;
            }
            if (!!groups) {
                var matchedGrps = groups.filter((group) => group.name.toLowerCase().includes(text.toLowerCase()));
                if (!!availableVals[i].groupIds) {
                    // eslint-disable-next-line
                    availableVals[i].groupIds.forEach((nodeGroupId) => {
                        if (matchedGrps.some(group => group.id === nodeGroupId)) {
                            filteredVals.push(availableVals[i]);
                        }
                    })
                }
            }
        }
        return filteredVals;
    } else return availableVals;
}

export const getFilteredGroupVals = (valGroups, filteredVals) => {
    var filterGrpsOfFilteredVals = [];
    valGroups.forEach(valGroup => {
        if (filteredVals.some(filteredVal => !!filteredVal.groupIds && filteredVal.groupIds.includes(valGroup.id))) {
            filterGrpsOfFilteredVals.push(valGroup);
        }
    })
    return filterGrpsOfFilteredVals;
}